/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRoleForm,
  CreateRoleForm$Outbound,
  CreateRoleForm$outboundSchema,
} from "../components/createroleform.js";

export type CreateRoleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreateRoleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createRoleForm: CreateRoleForm;
};

/** @internal */
export type CreateRoleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateRoleSecurity$outboundSchema: z.ZodMiniType<
  CreateRoleSecurity$Outbound,
  CreateRoleSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createRoleSecurityToJSON(
  createRoleSecurity: CreateRoleSecurity,
): string {
  return JSON.stringify(
    CreateRoleSecurity$outboundSchema.parse(createRoleSecurity),
  );
}

/** @internal */
export type CreateRoleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  CreateRoleForm: CreateRoleForm$Outbound;
};

/** @internal */
export const CreateRoleRequest$outboundSchema: z.ZodMiniType<
  CreateRoleRequest$Outbound,
  CreateRoleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    createRoleForm: CreateRoleForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      createRoleForm: "CreateRoleForm",
    });
  }),
);

export function createRoleRequestToJSON(
  createRoleRequest: CreateRoleRequest,
): string {
  return JSON.stringify(
    CreateRoleRequest$outboundSchema.parse(createRoleRequest),
  );
}
